const LOCALE = "pt-BR";

/**
 * "São Paulo, 6 de outubro de 2026": where and when the customer signs the
 * receipt. The day is the one in the provider's timezone, not the browser's.
 * Without a city it is just the date.
 * @param {string|null|undefined} city
 * @param {Date} now
 * @param {string|null|undefined} timezone an IANA name, "America/Sao_Paulo"
 */
export const receiptPlaceAndDate = (city, now, timezone) => {
    const date = now.toLocaleDateString(LOCALE, {
        day: "numeric",
        month: "long",
        year: "numeric",
        ...(timezone ? {timeZone: timezone} : {}),
    });
    const place = (city ?? "").trim();
    return place ? `${place}, ${date}` : date;
};

/**
 * The name the paper carries as the provider: the one set for receipts, or
 * the account owner's.
 * @param {{name_on_receipt?: string|null}|null|undefined} config
 * @param {string} owner
 */
export const printedProviderName = (config, owner) => (config?.name_on_receipt ?? "").trim() || owner;

/**
 * The attestation on the receipt: what the customer says they received, which
 * is their equipment and/or the products they bought, whichever the order has.
 * @param {{devices: boolean, products: boolean}} has
 * @param {number|string} number the order's number
 */
export const receiptSentence = ({devices, products}, number) => {
    const what =
        devices && products ? "meus equipamentos e os produtos" : devices ? "meus equipamentos" : "os produtos";
    return `Eu atesto que recebi ${what} listados abaixo, referentes à ordem de serviço #${number}.`;
};
